<template>
    <div class="computed-data">
        <p>a + b = {{computedData}}</p>
        <p>数字を変更すると計算結果が変わります。</p>
        <p>aの数字を入力：<input v-model="a" type="text"></p>
        <p>bの数字を入力：<input v-model="b" type="text"></p>
    </div>
</template>

<script>
export default {
    data(){
        return{
            a: 10,
            b: 20,
        }
    },
    computed:{
        computedData(){
            return Number(this.a) + Number(this.b);
        }
    }
}
</script>

<style scoped>
p{
    padding-bottom:20px;
}
</style>